export const ON_LICENSE_QUERY_INPUT_CHANGE = 'LICENSE/ON_LICENSE_QUERY_INPUT_CHANGE';

export const START_LOAD_LICENSE_EMPLOYEE_OPTIONS = 'LICENSE/START_LOAD_LICENSE_EMPLOYEE_OPTIONS';
export const LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS = 'LICENSE/LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS';
export const LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE = 'LICENSE/LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE';
export const INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS = 'LICENSE/INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS';

export const START_LOAD_LICENSE_INFO = 'LICENSE/START_LOAD_LICENSE_INFO';
export const LOAD_LICENSE_INFO_SUCCESS = 'LICENSE/LOAD_LICENSE_INFO_SUCCESS';
export const LOAD_LICENSE_INFO_FAILURE = 'LICENSE/LOAD_LICENSE_INFO_FAILURE';
export const INIT_LOAD_LICENSE_INFO_ACTION_STATUS = 'LICENSE/INIT_LOAD_LICENSE_INFO_ACTION_STATUS';

export const SELECT_LICENSE_INFO = 'LICENSE/SELECT_LICENSE_INFO';

export const OPEN_ADD_OR_EDIT_LICENSE_MODAL = 'LICENSE/OPEN_ADD_OR_EDIT_LICENSE_MODAL';
export const ADD_OR_EDIT_LICENSE_CHANGE_INPUT = 'LICENSE/ADD_OR_EDIT_LICENSE_CHANGE_INPUT';
export const START_ADD_OR_EDIT_LICENSE = 'LICENSE/START_ADD_OR_EDIT_LICENSE';
export const ADD_OR_EDIT_LICENSE_SUCCESS = 'LICENSE/ADD_OR_EDIT_LICENSE_SUCCESS';
export const ADD_OR_EDIT_LICENSE_FAILURE = 'LICENSE/ADD_OR_EDIT_LICENSE_FAILURE';
export const INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS = 'LICENSE/INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS';
export const RESET_ADD_OR_EDIT_LICENSE_MODAL = 'LICENSE/RESET_ADD_OR_EDIT_LICENSE_MODAL';

export const OPEN_DEL_LICENSE_MODAL = 'LICENSE/OPEN_DEL_LICENSE_MODAL';
export const START_DEL_LICENSE = 'LICENSE/START_DEL_LICENSE';
export const DEL_LICENSE_SUCCESS = 'LICENSE/DEL_LICENSE_SUCCESS';
export const DEL_LICENSE_FAILURE = 'LICENSE/DEL_LICENSE_FAILURE';
export const INIT_DEL_LICENSE_ACTION_STATUS = 'LICENSE/INIT_DEL_LICENSE_ACTION_STATUS';
export const RESET_DEL_LICENSE_MODAL = 'LICENSE/RESET_DEL_LICENSE_MODAL';

export const START_LOAD_LICENSE_NOTE = 'LICENSE/START_LOAD_LICENSE_NOTE';
export const LOAD_LICENSE_NOTE_SUCCESS = 'LICENSE/LOAD_LICENSE_NOTE_SUCCESS';
export const LOAD_LICENSE_NOTE_FAILURE = 'LICENSE/LOAD_LICENSE_NOTE_FAILURE';
export const INIT_LOAD_LICENSE_NOTE_ACTION_STATUS = 'LICENSE/INIT_LOAD_LICENSE_NOTE_ACTION_STATUS';
export const LICENSE_NOTE_CHANGE_INPUT = 'LICENSE/LICENSE_NOTE_CHANGE_INPUT';
export const START_ADD_OR_EDIT_LICENSE_NOTE = 'LICENSE/START_ADD_OR_EDIT_LICENSE_NOTE';
export const ADD_OR_EDIT_LICENSE_NOTE_SUCCESS = 'LICENSE/ADD_OR_EDIT_LICENSE_NOTE_SUCCESS';
export const ADD_OR_EDIT_LICENSE_NOTE_FAILURE = 'LICENSE/ADD_OR_EDIT_LICENSE_NOTE_FAILURE';
export const INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS = 'LICENSE/INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS';
export const RESET_LICENSE_NOTE_MODAL = 'LICENSE/RESET_LICENSE_NOTE_MODAL';
